var characters = require("./characters");

module.exports = new RegExp('[' + characters.join('') + ']', 'g');



/*****************
 ** WEBPACK FOOTER
 ** ./~/anglicize/lib/re.js
 ** module id = 573
 ** module chunks = 0
 **/